import { z } from 'zod'

import type { NoContext } from '~/services/api/contracts/NoContext'
import { PayableTypeSchema, PayableConnectedAccountRequestSchema } from '~/services/api/generated'
import { strictify } from '~/utils/strictify'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({
  enums: [{ field: 'payable_type', options: PayableTypeSchema.options }],
  int: ['payable_id']
})

const PaymentOnboardingCreateChildSchema = strictify(PayableConnectedAccountRequestSchema)

export const PaymentOnboardingCreateChild = (
  _context: NoContext = {}
): z.ZodType<z.output<typeof PaymentOnboardingCreateChildSchema>> =>
  z.preprocess(normalize, PaymentOnboardingCreateChildSchema)
